import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const inputCls =
  "w-full bg-surface border border-white/10 focus:border-gold px-4 py-3 text-sm text-white placeholder:text-zinc-500 outline-none transition-colors duration-300";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-4 bg-ink">
      <Seo title="Admin Login | B&H Truck Dispatching" description="Administrator access for B&H Truck Dispatching." />
      <form onSubmit={submit} data-testid="admin-login-form" className="card-gold w-full max-w-md p-8 sm:p-12">
        <Logo size="lg" className="mx-auto mb-6" testId="admin-login-logo" />
        <h1 className="font-display text-2xl sm:text-3xl font-bold uppercase text-white text-center mb-2">Admin Access</h1>
        <p className="text-xs text-zinc-500 text-center mb-8 uppercase tracking-[0.2em]">B&amp;H Truck Dispatching</p>
        <div className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-400 block mb-2">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              className={inputCls}
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              placeholder="admin@bhtruckdispatching.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-400 block mb-2">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              className={inputCls}
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              placeholder="••••••••••"
            />
          </div>
          <button type="submit" data-testid="admin-login-submit-btn" disabled={loading} className="btn-gold w-full disabled:opacity-50 disabled:pointer-events-none">
            <Lock size={15} /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </main>
  );
}
